// src/modules/soe/SoeDashboard.js
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { db, paths } from '../../firebase/config';
import {
  collection,
  onSnapshot,
  doc, 
  updateDoc,
  deleteDoc, 
  getDoc 
} from "firebase/firestore";
import { useAuth, logAuditoria } from '../../context/AuthContext';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { Button } from '../../components/Button';
import { formatarData, getNormalizedDateString } from '../../utils/helpers';
import { Modal } from '../../components/Modal'; 
import { RelatorioEstagioModal } from '../../components/RelatorioEstagioModal';
import CadeteMap from '../../components/CadeteMap';

// --- Ícones (Estilo Moderno) ---
const SearchIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
);
const ChartBarIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg>
);
const MapIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" /></svg>
);
const UserSearchIcon = () => (
  <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
);
const FileTextIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
);
const PrinterIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" /></svg>
);
const CertificateIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
);
// ADICIONADO: Ícone para a nova aba
const ClipboardListIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></svg>
);

export const SoeDashboard = () => {
  const { userProfile } = useAuth();
  const [loading, setLoading] = useState(true);
  
  // Estados para dados globais
  const [todasEscolhas, setTodasEscolhas] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [allPelotoes, setAllPelotoes] = useState([]);
  const [allLocais, setAllLocais] = useState([]);
  const [allRelatorios, setAllRelatorios] = useState([]);
  
  // Estados de Filtro (Pesquisa)
  const [filters, setFilters] = useState({ pelotaoId: '', localId: '', data: '', status: '', tipo: '' });
  const [searchTerm, setSearchTerm] = useState(''); 
  const [searchPerformed, setSearchPerformed] = useState(false); 
  
  // Controle de Interface
  const [activeTab, setActiveTab] = useState('pesquisa'); // 'pesquisa', 'gerenciar_escolhas', 'locais', 'graficos', 'mapa'
  
  // Estados para o Mês Selecionado (Mapa)
  const [selectedMonthTab, setSelectedMonthTab] = useState(''); 
  const [selectedDateTab, setSelectedDateTab] = useState(''); 
  
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  
  // Refs dos Gráficos
  const chartPcoMaisRef = useRef(null);
  const chartPcoMenosRef = useRef(null);
  const chartPjMaisRef = useRef(null);
  const chartPjMenosRef = useRef(null);
  const chartPcoMaisInstanceRef = useRef(null);
  const chartPcoMenosInstanceRef = useRef(null);
  const chartPjMaisInstanceRef = useRef(null);
  const chartPjMenosInstanceRef = useRef(null);
  
  // Estados da Certidão
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [isProcessingSignature, setIsProcessingSignature] = useState(false);
  const [certificateCadete, setCertificateCadete] = useState(null); 
  const [signatureData, setSignatureData] = useState({ nome1: '', posto1: '', nome2: '', posto2: '' });
  
  // Estados de Relatório (Visualização)
  const [showReportViewModal, setShowReportViewModal] = useState(false);
  const [reportViewData, setReportViewData] = useState(null); 
  const [reportViewEscolha, setReportViewEscolha] = useState(null); 

  // ADICIONADO: Estados para Exclusão
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteAction, setDeleteAction] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const chartScriptId = 'chartjs-cdn-script';
    const chartScriptUrl = 'https://cdn.jsdelivr.net/npm/chart.js@4.4.3/dist/chart.umd.min.js';
    if (typeof window.Chart !== 'undefined') { setIsScriptLoaded(true); return; }
    let script = document.getElementById(chartScriptId);
    const handleScriptLoad = () => setIsScriptLoaded(true);
    if (script) { script.addEventListener('load', handleScriptLoad); } 
    else { script = document.createElement('script'); script.id = chartScriptId; script.src = chartScriptUrl; script.async = true; script.addEventListener('load', handleScriptLoad); document.body.appendChild(script); }
    return () => { if (script) script.removeEventListener('load', handleScriptLoad); };
  }, []);

  useEffect(() => {
    setLoading(true);
    const unsubEscolhas = onSnapshot(collection(db, paths.escolhas), (snapshot) => { setTodasEscolhas(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); }, (err) => console.error("Erro (SOE Escolhas):", err));
    const unsubUsers = onSnapshot(collection(db, paths.users), (snapshot) => { setAllUsers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); }, (err) => console.error("Erro (SOE Usuários):", err));
    const unsubPelotoes = onSnapshot(collection(db, paths.pelotoes), (snapshot) => { setAllPelotoes(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); }, (err) => console.error("Erro (SOE Pelotões):", err));
    const unsubLocais = onSnapshot(collection(db, paths.locais), (snapshot) => { setAllLocais(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); }, (err) => console.error("Erro (SOE Locais):", err));
    const unsubRelatorios = onSnapshot(collection(db, paths.relatoriosEstagio), (snapshot) => { setAllRelatorios(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); }, (err) => console.error("Erro (SOE Relatórios):", err));
    setLoading(false);
    return () => { unsubEscolhas(); unsubUsers(); unsubPelotoes(); unsubLocais(); unsubRelatorios(); };
  }, []);

  const userMap = useMemo(() => new Map(allUsers.map(u => [u.id, u])), [allUsers]);
  const pelotaoMap = useMemo(() => new Map(allPelotoes.map(p => [p.id, p])), [allPelotoes]);
  const relatorioMap = useMemo(() => new Map(allRelatorios.map(r => [r.escolha_id, r])), [allRelatorios]);
  const hojeStr = useMemo(() => getNormalizedDateString(new Date()), []);

  // ... Lógica de Gráficos e Tabelas ...
  const chartData = useMemo(() => {
    const pcoCounts = new Map(); const pjCounts = new Map();
    allLocais.forEach(local => { if (local.tipo === 'PCO') { pcoCounts.set(local.nome, 0); } else if (local.tipo === 'PJ') { pjCounts.set(local.nome, 0); } });
    
    todasEscolhas.forEach(e => { if (!e.opcao_impossibilidade && e.local_nome) { if (pcoCounts.has(e.local_nome)) { pcoCounts.set(e.local_nome, (pcoCounts.get(e.local_nome) || 0) + 1); } else if (pjCounts.has(e.local_nome)) { pjCounts.set(e.local_nome, (pjCounts.get(e.local_nome) || 0) + 1); } } });
    
    const sortedPCO = [...pcoCounts.entries()].sort((a, b) => a[1] - b[1]);
    const sortedPJ = [...pjCounts.entries()].sort((a, b) => a[1] - b[1]);
    
    const formatChartData = (data) => ({ labels: data.map(item => item[0]), data: data.map(item => item[1]) });
    
    const fullPCOList = [...sortedPCO].reverse();
    const fullPJList = [...sortedPJ].reverse();

    return { 
        pcoMenos: formatChartData(sortedPCO.slice(0, 3)), 
        pcoMais: formatChartData(sortedPCO.length > 3 ? sortedPCO.slice(-3).reverse() : [...sortedPCO].reverse()), 
        pjMenos: formatChartData(sortedPJ.slice(0, 3)), 
        pjMais: formatChartData(sortedPJ.length > 3 ? sortedPJ.slice(-3).reverse() : [...sortedPJ].reverse()),
        fullPCO: fullPCOList,
        fullPJ: fullPJList
    };
  }, [todasEscolhas, allLocais]); 

  const renderChart = (canvasRef, instanceRef, chartData, title, backgroundColor) => {
    if (!canvasRef.current) return;
    if (instanceRef.current) instanceRef.current.destroy(); 
    try { if (window.Chart.BarElement) { window.Chart.register(window.Chart.BarElement, window.Chart.CategoryScale, window.Chart.LinearScale, window.Chart.Title, window.Chart.Tooltip, window.Chart.Legend); } } catch (e) {}
    const ctx = canvasRef.current.getContext('2d');
    instanceRef.current = new window.Chart(ctx, { 
        type: 'bar', 
        data: { 
            labels: chartData.labels, 
            datasets: [{ 
                label: 'Nº de Escolhas', 
                data: chartData.data, 
                backgroundColor: backgroundColor, 
                borderColor: backgroundColor.replace('0.6', '1'), 
                borderWidth: 1,
                borderRadius: 4, 
                barPercentage: 0.7 
            }] 
        }, 
        options: { 
            responsive: true, 
            maintainAspectRatio: false, 
            indexAxis: 'y', 
            plugins: { 
                legend: { display: false }, 
                title: { display: true, text: title, font: { size: 14, weight: 'bold' }, color: '#4b5563', padding: { bottom: 20 } } 
            }, 
            scales: { 
                x: { beginAtZero: true, ticks: { stepSize: 1, font: { size: 10 } }, grid: { display: false } }, 
                y: { ticks: { font: { size: 11 }, autoSkip: false }, grid: { display: false } } 
            } 
        } 
    });
  };

  useEffect(() => {
    if (isScriptLoaded && activeTab === 'graficos' && typeof window.Chart !== 'undefined') {
      renderChart(chartPcoMaisRef, chartPcoMaisInstanceRef, chartData.pcoMais, 'PCO - Mais Escolhidos (Top 3)', 'rgba(59, 130, 246, 0.7)'); 
      renderChart(chartPcoMenosRef, chartPcoMenosInstanceRef, chartData.pcoMenos, 'PCO - Menos Escolhidos (Bottom 3)', 'rgba(249, 115, 22, 0.7)'); 
      renderChart(chartPjMaisRef, chartPjMaisInstanceRef, chartData.pjMais, 'PJ - Mais Escolhidos (Top 3)', 'rgba(16, 185, 129, 0.7)'); 
      renderChart(chartPjMenosRef, chartPjMenosInstanceRef, chartData.pjMenos, 'PJ - Menos Escolhidos (Bottom 3)', 'rgba(239, 68, 68, 0.7)'); 
    }
  }, [chartData, isScriptLoaded, activeTab]);

  // ... Lógica de Dados para Pesquisa ...
  const filteredEscolhas = useMemo(() => {
    if (!searchPerformed) return [];
    let items = todasEscolhas;
    const term = searchTerm.toLowerCase().trim();
    if (term) { items = items.filter(e => { const cadete = userMap.get(e.cadete_id); const nome = cadete?.nome || e.cadete_nome || ''; const cpf = cadete?.cpf || ''; const matricula = cadete?.matricula || ''; return (nome.toLowerCase().includes(term) || cpf.includes(term) || matricula.toLowerCase().includes(term)); }); }
    if (filters.pelotaoId) items = items.filter(e => e.pelotao_id === filters.pelotaoId);
    if (filters.localId) items = items.filter(e => e.local_id === filters.localId);
    if (filters.data) items = items.filter(e => e.data && getNormalizedDateString(e.data) === filters.data);
    if (filters.tipo) items = items.filter(e => e.tipo === filters.tipo);
    if (filters.status) {
      if (filters.status === 'realizado') { items = items.filter(e => !e.opcao_impossibilidade && e.data && getNormalizedDateString(e.data) < hojeStr); } 
      else if (filters.status === 'agendado') { items = items.filter(e => !e.opcao_impossibilidade && e.data && getNormalizedDateString(e.data) >= hojeStr); } 
      else if (filters.status === 'impossibilidade') { items = items.filter(e => e.opcao_impossibilidade); }
    }
    return items.sort((a, b) => (a.data?.toDate() || 0) - (b.data?.toDate() || 0));
  }, [todasEscolhas, filters, searchTerm, searchPerformed, userMap, hojeStr]);

  // ... Lógica de Mapa ...
  const diasAgrupados = useMemo(() => {
      const grupos = {};
      todasEscolhas.forEach(escolha => {
          if (escolha.opcao_impossibilidade || !escolha.data) return;
          const dataStr = getNormalizedDateString(escolha.data);
          if (!grupos[dataStr]) {
              grupos[dataStr] = {
                  dataStr: dataStr,
                  dataDisplay: formatarData(escolha.data),
                  data: escolha.data, 
                  itens: []
              };
          }
          grupos[dataStr].itens.push(escolha);
      });
      return Object.values(grupos).sort((a, b) => a.data.toDate() - b.data.toDate());
  }, [todasEscolhas]);

  const mesesAgrupados = useMemo(() => {
      const meses = {};
      diasAgrupados.forEach(dia => {
          const data = dia.data.toDate();
          const mesKey = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
          const mesNome = data.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
          if (!meses[mesKey]) {
              meses[mesKey] = { key: mesKey, nome: mesNome, dias: [] };
          }
          meses[mesKey].dias.push(dia);
      });
      return Object.values(meses).sort((a, b) => a.key.localeCompare(b.key));
  }, [diasAgrupados]);

  useEffect(() => {
      if (mesesAgrupados.length > 0 && !selectedMonthTab) {
          setSelectedMonthTab(mesesAgrupados[0].key);
      }
  }, [mesesAgrupados, selectedMonthTab]);

  useEffect(() => {
      if (selectedMonthTab) {
          const mesAtual = mesesAgrupados.find(m => m.key === selectedMonthTab);
          if (mesAtual && mesAtual.dias.length > 0) {
              const diaAtualValido = mesAtual.dias.some(d => d.dataStr === selectedDateTab);
              if (!diaAtualValido) {
                  setSelectedDateTab(mesAtual.dias[0].dataStr);
              }
          }
      }
  }, [selectedMonthTab, mesesAgrupados, selectedDateTab]);

  const mapData = useMemo(() => {
      if (!selectedDateTab || !diasAgrupados.length) return [];
      const diaAtual = diasAgrupados.find(d => d.dataStr === selectedDateTab);
      if (!diaAtual) return [];
      const groupedByLocation = {};
      diaAtual.itens.forEach(item => {
          const localId = item.local_id;
          const localInfo = allLocais.find(l => l.id === localId);
          if (localInfo && localInfo.latitude && localInfo.longitude) {
              if (!groupedByLocation[localId]) {
                  groupedByLocation[localId] = {
                      ...localInfo,
                      data_escolha: item.data,
                      tipo_escolha: item.tipo,
                      cadetes: [] 
                  };
              }
              const pelotaoInfo = pelotaoMap.get(item.pelotao_id);
              const pelotaoNome = pelotaoInfo?.nome || item.pelotao_origem || 'N/D';
              groupedByLocation[localId].cadetes.push(`${item.cadete_nome} (${pelotaoNome})`);
          }
      });
      return Object.values(groupedByLocation);
  }, [selectedDateTab, diasAgrupados, allLocais, pelotaoMap]);


  // --- Handlers Gerais ---
  
  const handleOpenModalLocal = (local) => {
      console.log(`Abrir modal para ${local ? 'editar ' + local.nome : 'criar novo local'}`);
      // Implementação real da lógica de modal para Local (se necessário no SOE)
  };
  
  // --- NOVA FUNÇÃO: Confirmar Exclusão ---
  const confirmDelete = (id) => {
      setDeleteAction({ id });
      setShowConfirm(true);
  };

  // --- NOVA FUNÇÃO: Executar Exclusão ---
  const handleDelete = async () => {
    if (!deleteAction) return;
    const { id } = deleteAction;
    
    try {
        const escolhaDoc = await getDoc(doc(db, paths.escolhas, id));
        if (!escolhaDoc.exists()) throw new Error("Escolha não encontrada.");
        
        await deleteDoc(doc(db, paths.escolhas, id));
        
        await logAuditoria(userProfile, "Exclusão de Escolha (SOE)", { id });
        
        setShowConfirm(false);
        setDeleteAction(null);
        setError('');
        
    } catch (err) {
        console.error("Erro ao excluir:", err);
        setError(err.message);
        setShowConfirm(false);
    }
  };

  const certificateStatus = useMemo(() => {
    if (!searchPerformed || filteredEscolhas.length === 0) {
      return { enabled: false, message: "Realize uma pesquisa primeiro." };
    }
    const uniqueCadeteIds = new Set(filteredEscolhas.map(e => e.cadete_id));
    if (uniqueCadeteIds.size > 1) {
      return { enabled: false, message: "Filtre por um único cadete para gerar a certidão." };
    }
    if (uniqueCadeteIds.size === 0) {
       return { enabled: false, message: "Nenhum cadete encontrado." };
    }
    const cadeteId = uniqueCadeteIds.values().next().value;
    let cadete = userMap.get(cadeteId);
    if (!cadete) {
        const firstChoice = filteredEscolhas[0];
        cadete = {
            id: firstChoice.cadete_id,
            nome: firstChoice.cadete_nome,
            cpf: 'Externo', 
            matricula: 'Externo'
        };
    }
    const estagiosRealizados = filteredEscolhas.filter(e => !e.opcao_impossibilidade && e.data && getNormalizedDateString(e.data) < hojeStr);
    if (estagiosRealizados.length === 0) {
      return { enabled: false, message: "Este cadete não possui estágios realizados." };
    }
    return { enabled: true, message: `Gerar certidão para ${cadete?.nome}`, cadete };
  }, [filteredEscolhas, searchPerformed, userMap, hojeStr]);

  const handleFilterChange = (e) => { const { name, value } = e.target; setFilters(prev => ({ ...prev, [name]: value })); };
  const handleSearchTermChange = (e) => { setSearchTerm(e.target.value); };
  const clearFilters = () => { setFilters({ pelotaoId: '', localId: '', data: '', status: '', tipo: '' }); setSearchTerm(''); setSearchPerformed(false); };
  const handleSearch = () => { if (filters.pelotaoId || filters.localId || filters.data || filters.status || filters.tipo || searchTerm) { setSearchPerformed(true); } else { setSearchPerformed(false); } };
  
  const handleGenerateReport = () => {
    if (!searchPerformed || filteredEscolhas.length === 0) { alert("Por favor, realize uma pesquisa com resultados antes de gerar um relatório."); return; }
    const dataGeracao = new Date().toLocaleString('pt-BR');
    let tableHtml = `<table class="w-full border-collapse"><thead><tr class="bg-gray-200"><th class="border p-2 text-left">Data</th><th class="border p-2 text-left">Cadete</th><th class="border p-2 text-left">RE/CPF</th><th class="border p-2 text-left">Pelotão</th><th class="border p-2 text-left">Local</th><th class="border p-2 text-left">Status</th><th class="border p-2 text-left">Turno</th></tr></thead><tbody>`;
    filteredEscolhas.forEach(e => {
        const cadete = userMap.get(e.cadete_id); const pelotao = pelotaoMap.get(e.pelotao_id);
        const nomeDisplay = cadete?.nome || e.cadete_nome; const reDisplay = cadete?.matricula ? `RE: ${cadete.matricula}` : (cadete?.cpf ? `CPF: ${cadete.cpf}` : 'Externo'); const pelotaoDisplay = pelotao?.nome || e.pelotao_origem || 'N/D';
        let statusStr = 'N/A';
        if (e.opcao_impossibilidade) { statusStr = 'Impossibilidade'; } else if (e.data) { const dataEstagioStr = getNormalizedDateString(e.data); statusStr = (dataEstagioStr < hojeStr) ? 'Realizado' : 'Agendado'; }
        tableHtml += `<tr class="hover:bg-gray-50"><td class="border p-2">${e.data ? formatarData(e.data) : 'N/D'}</td><td class="border p-2">${nomeDisplay}</td><td class="border p-2">${reDisplay}</td><td class="border p-2">${pelotaoDisplay}</td><td class="border p-2">${e.local_nome || 'N/D'}</td><td class="border p-2">${statusStr}</td><td class="border p-2">${e.turno || 'N/A'}</td></tr>`;
    });
    tableHtml += `</tbody></table>`;
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
        <head>
          <title>Relatório de Estágios SOE</title>
          <script src="https://cdn.tailwindcss.com"></script>
          <style> 
            @page { size: A4 landscape; margin: 1.5cm; } 
            body { font-family: "Inter", sans-serif; font-size: 9pt; } 
            table { width: 100%; border-collapse: collapse; } 
            th, td { border: 1px solid #ccc; padding: 4px; text-align: left; } 
            th { background-color: #f2f2f2; } 
            .no-print { display: none; } 
          </style>
        </head>
        <body class="p-4">
          <div class="flex items-center justify-between mb-4">
            <div class="flex items-center space-x-2">
              <img src="brasao.png" alt="Brasão" class="h-16 w-16" onerror="this.style.display='none'">
              <div>
                <h1 class="text-xl font-bold text-gray-800">Relatório de Gestão de Estágios (SOE)</h1>
                <p class="text-sm text-gray-600">Gerado em: ${dataGeracao}</p>
              </div>
            </div>
            <button onclick="window.print()" class="no-print bg-blue-600 text-white px-4 py-2 rounded-lg" style="margin-left: auto;">Imprimir</button>
          </div>
          ${tableHtml}
          <footer class="text-center text-xs text-gray-500 mt-4 pt-4 border-t">Relatório gerado pelo SIAAP - Sistema Integrado Acadêmico da APMBB</footer>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const handleOpenReportView = (escolha) => { const relatorio = relatorioMap.get(escolha.id); if (!relatorio) return; setReportViewEscolha(escolha); setReportViewData(relatorio); setShowReportViewModal(true); };
  
  const handleOpenSignatureModal = () => { 
      if (!certificateStatus.enabled) return; 
      setCertificateCadete(certificateStatus.cadete); 
      setSignatureData({ 
          nome1: userProfile.assinaturaSoeNome1 || '', 
          posto1: userProfile.assinaturaSoePosto1 || 'Ch C Op Ens', 
          nome2: userProfile.assinaturaSoeNome2 || '', 
          posto2: userProfile.assinaturaSoePosto2 || 'Cmt Corpo de Alunos', 
      }); 
      setShowSignatureModal(true); 
  };
  
  const handleSignatureFormChange = (e) => { const { name, value } = e.target; setSignatureData(prev => ({...prev, [name]: value})); };
  
  const handleSaveAndGenerateCertificate = async () => {
    setIsProcessingSignature(true);
    try { 
        const userDocRef = doc(db, paths.users, userProfile.id); 
        await updateDoc(userDocRef, { 
            assinaturaSoeNome1: signatureData.nome1, 
            assinaturaSoePosto1: signatureData.posto1, 
            assinaturaSoeNome2: signatureData.nome2, 
            assinaturaSoePosto2: signatureData.posto2, 
        }); 
    } catch (err) { 
        console.error("Erro ao salvar assinaturas:", err); 
    }
    
    const cadete = certificateCadete; 
    const estagiosRealizados = filteredEscolhas.filter(e => e.cadete_id === cadete.id && !e.opcao_impossibilidade && e.data && getNormalizedDateString(e.data) < hojeStr).sort((a, b) => (a.data?.toDate() || 0) - (b.data?.toDate() || 0));
    const dataGeracao = new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
    
    let estagiosHtml = '<ul class="list-disc list-inside space-y-1 mt-4">'; 
    estagiosRealizados.forEach(e => { 
        estagiosHtml += `<li>Em ${formatarData(e.data)}, no(a) ${e.local_nome} (${e.tipo}).</li>`; 
    }); 
    estagiosHtml += '</ul>';
    
    const printWindow = window.open('', '_blank');
    
    printWindow.document.write(`
      <html>
        <head>
          <title>Certidão - ${cadete.nome}</title>
          <script src="https://cdn.tailwindcss.com"></script>
          <style> 
            @page { size: A4 portrait; margin: 2.5cm; } 
            body { font-family: "Inter", sans-serif; font-size: 11pt; line-height: 1.5; } 
            .content { width: 100%; height: 100%; display: flex; flex-direction: column; } 
            .brasao { height: 80px; width: 80px; margin: 0 auto 1rem auto; } 
            .assinatura { width: 60%; text-align: center; border-top: 1px solid #000; padding-top: 5px; } 
            .no-print { display: none; } 
          </style>
        </head>
        <body class="p-4">
          <div class="content">
            <header class="text-center mb-6">
              <img src="brasao.png" alt="Brasão" class="brasao" onerror="this.style.display='none'">
              <p class="font-bold">POLÍCIA MILITAR DO ESTADO DE SÃO PAULO</p>
              <p class="font-bold">ACADEMIA DE POLÍCIA MILITAR DO BARRO BRANCO</p>
              <p>Seção Operacional Escolar (SOE)</p>
            </header>
            <h1 class="text-2xl font-bold text-center my-8">CERTIDÃO</h1>
            <main class="flex-grow">
              <p class="text-justify indent-8">
                Certifico, para os devidos fins, que o(a) ${cadete.nome}, portador(a) do CPF nº ${cadete.cpf}, realizou os seguintes estágios curriculares do Curso de Formação de Oficiais, com duração de 12 (doze) horas cada:
              </p>
              ${estagiosHtml}
              <p class="mt-8 text-justify indent-8">Nada mais a certificar.</p>
            </main>
            <footer class="mt-16">
              <p class="text-right mb-16">São Paulo, ${dataGeracao}</p>
              <div class="flex flex-col items-center space-y-10">
                <div class="assinatura">
                  <p class="font-bold">${signatureData.nome1.toUpperCase()}</p>
                  <p class="text-sm">${signatureData.posto1}</p>
                </div>
                <div class="assinatura">
                  <p class="font-bold">${signatureData.nome2.toUpperCase()}</p>
                  <p class="text-sm">${signatureData.posto2}</p>
                </div>
              </div>
            </footer>
          </div>
        </body>
      </html>
    `);
    
    printWindow.document.close(); 
    setIsProcessingSignature(false); 
    setShowSignatureModal(false);
  };
  
  // --- NOVA FUNÇÃO: Renderizar Tabela de Gerenciamento ---
  const renderGerenciarEscolhas = () => (
      <div className="space-y-6 animate-fade-in">
          <div className="flex justify-between items-center">
            <h3 className="text-xl font-semibold text-gray-800">Gerenciar Todas as Escolhas</h3>
            <span className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full">{todasEscolhas.length} registros</span>
          </div>
          
          <div className="bg-white shadow rounded-lg overflow-x-auto border border-gray-200">
              <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                      <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pelotão</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cadete</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Local / Tipo</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                          <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                      </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                      {todasEscolhas.sort((a, b) => (b.criado_em?.toDate() || 0) - (a.criado_em?.toDate() || 0)).map(e => {
                          // Cruzamento de dados usando os Maps já criados no componente
                          const cadete = userMap.get(e.cadete_id);
                          const nomeDisplay = cadete?.nome || e.cadete_nome || 'N/D';
                          const pelotao = pelotaoMap.get(e.pelotao_id);
                          const pelotaoDisplay = e.pelotao_origem || pelotao?.nome || 'N/D';

                          return (
                              <tr key={e.id} className="hover:bg-gray-50">
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{pelotaoDisplay}</td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 font-medium">{nomeDisplay}</td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                      {e.opcao_impossibilidade 
                                        ? <span className={`font-semibold ${e.data ? 'text-orange-600' : 'text-red-600'}`}>{e.local_nome}</span>
                                        : `${e.local_nome} (${e.tipo})`}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                      {e.data ? formatarData(e.data) : 'N/D (Geral)'}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                                      {e.opcao_impossibilidade 
                                        ? <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${e.data ? 'bg-orange-100 text-orange-800' : 'bg-red-100 text-red-800'}`}>{e.data ? 'PULO (Dia)' : 'PULO (Geral)'}</span>
                                        : <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">ESCOLHA REAL</span>
                                      }
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                      <Button onClick={() => confirmDelete(e.id)} variant="danger" className="text-xs py-1 px-2">Excluir</Button>
                                  </td>
                              </tr>
                          );
                      })}
                      {todasEscolhas.length === 0 && (<tr><td colSpan="6" className="text-center py-8 text-gray-500">Nenhuma escolha registrada no sistema.</td></tr>)}
                  </tbody>
              </table>
          </div>
      </div>
  );
  
  // MAPA PARA CLASSES TAILWIND DINÂMICAS (Corrigindo problema de JIT)
  const colorMap = {
      blue: { bgLight: 'bg-blue-50', text: 'text-blue-800', bgDark: 'bg-blue-500' },
      green: { bgLight: 'bg-green-50', text: 'text-green-800', bgDark: 'bg-green-500' },
  };

  if (loading) return <LoadingSpinner text="Carregando dados globais..." />;

  const mesSelecionadoObj = mesesAgrupados.find(m => m.key === selectedMonthTab);

  const RankingTable = ({ title, data, color }) => {
      const colors = colorMap[color] || { bgLight: 'bg-gray-50', text: 'text-gray-800', bgDark: 'bg-gray-500' };

      return (
          <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
              <div className={`p-3 border-b border-gray-200 ${colors.bgLight}`}>
                  <h4 className={`text-lg font-bold ${colors.text}`}>{title}</h4>
              </div>
              <div className="overflow-y-auto max-h-96">
                  <table className="w-full text-sm">
                      <thead className="bg-gray-50 text-gray-500 uppercase text-xs sticky top-0">
                          <tr>
                              <th className="p-3 text-left">Local</th>
                              <th className="p-3 text-right">Qtd.</th>
                          </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100">
                          {data.map((item, idx) => {
                              const maxVal = data.length > 0 ? data[0][1] : 1;
                              const percent = (item[1] / maxVal) * 100;
                              return (
                                  <tr key={idx} className="hover:bg-gray-50 group">
                                      <td className="p-3">
                                          <div className="flex flex-col">
                                              <span className="font-medium text-gray-700 z-10 relative">{item[0]}</span>
                                              <div className="h-1.5 bg-gray-100 rounded-full mt-1 overflow-hidden">
                                                  <div 
                                                      className={`h-full ${colors.bgDark} opacity-50`} 
                                                      style={{ width: `${percent}%` }}
                                                  ></div>
                                              </div>
                                          </div>
                                      </td>
                                      <td className="p-3 text-right font-bold text-gray-800">{item[1]}</td>
                                  </tr>
                              );
                          })}
                          {data.length === 0 && <tr><td colSpan="2" className="p-4 text-center text-gray-400">Nenhum dado.</td></tr>}
                      </tbody>
                  </table>
              </div>
          </div>
      );
  };

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800">Gestão de Estágios </h1>
        <p className="text-gray-600">Bem-vindo(a), {userProfile.nome}</p>
      </header>
      
      {/* Exibição de Erros */}
      {error && <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg flex justify-between"><strong>Erro:</strong> {error} <button onClick={() => setError('')}>x</button></div>}

      {/* Navegação de Abas */}
      <div className="flex justify-start mb-6 overflow-x-auto pb-2">
          <div className="flex space-x-2 bg-white p-2 rounded-2xl shadow-sm border border-gray-200">
              <button onClick={() => setActiveTab('pesquisa')} className={`flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200 ease-in-out ${activeTab === 'pesquisa' ? 'bg-blue-600 text-white shadow-md transform scale-105' : 'text-gray-600 hover:bg-gray-100'}`}><SearchIcon /> Pesquisa e Certidões</button>
              <button onClick={() => setActiveTab('gerenciar_escolhas')} className={`flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200 ease-in-out ${activeTab === 'gerenciar_escolhas' ? 'bg-blue-600 text-white shadow-md transform scale-105' : 'text-gray-600 hover:bg-gray-100'}`}><ClipboardListIcon /> Gerenciar Escolhas</button>
              <button onClick={() => setActiveTab('locais')} className={`flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200 ease-in-out ${activeTab === 'locais' ? 'bg-blue-600 text-white shadow-md transform scale-105' : 'text-gray-600 hover:bg-gray-100'}`}><SearchIcon /> Locais de estágios</button>
              <button onClick={() => setActiveTab('graficos')} className={`flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200 ease-in-out ${activeTab === 'graficos' ? 'bg-blue-600 text-white shadow-md transform scale-105' : 'text-gray-600 hover:bg-gray-100'}`}><ChartBarIcon /> Estatísticas</button>
              <button onClick={() => setActiveTab('mapa')} className={`flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200 ease-in-out ${activeTab === 'mapa' ? 'bg-blue-600 text-white shadow-md transform scale-105' : 'text-gray-600 hover:bg-gray-100'}`}><MapIcon /> Mapa Geral</button>
          </div>
      </div>

      <div className="space-y-6">
      
        {/* ABA PESQUISA (REDESENHADA PARA SER COMPACTA) */}
        {activeTab === 'pesquisa' && (
            <div className="animate-fade-in">
                {/* --- NOVO DESIGN DO CARD DE FILTROS COMPACTO --- */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-4 overflow-hidden">
                    <div className="flex justify-between items-center p-3 border-b bg-gray-50">
                        <div className="flex items-center gap-2 text-gray-700 font-bold text-sm">
                            <SearchIcon /> 
                            <span>Filtros de Pesquisa</span>
                        </div>
                        <div className="flex gap-2">
                            <Button 
                                onClick={clearFilters} 
                                variant="secondary" 
                                className="text-xs px-3 py-1 h-8"
                            >
                                Limpar
                            </Button>
                            
                            <Button 
                                onClick={handleGenerateReport} 
                                variant="outline" 
                                disabled={!searchPerformed || filteredEscolhas.length === 0}
                                className="text-xs px-3 py-1 h-8 flex items-center gap-1 border-gray-300 text-gray-700"
                                title="Gerar Relatório PDF"
                            >
                                <PrinterIcon /> Relatório
                            </Button>
                            
                            <Button 
                                onClick={handleOpenSignatureModal} 
                                variant="outline" 
                                className="text-xs px-3 py-1 h-8 flex items-center gap-1 border-green-600 text-green-700 hover:bg-green-50" 
                                disabled={!certificateStatus.enabled} 
                                title={certificateStatus.message}
                            >
                                <CertificateIcon /> Certidão
                            </Button>
                        </div>
                    </div>

                    <div className="p-3 grid grid-cols-1 md:grid-cols-12 gap-3 items-end">
                        <div className="col-span-12 md:col-span-4">
                            <label className="block text-[10px] font-bold text-gray-500 uppercase mb-1">Buscar (Nome, CPF, RE)</label>
                            <div className="relative">
                                <UserSearchIcon />
                                <input 
                                    name="searchTerm" 
                                    type="text" 
                                    placeholder="Digite para buscar..." 
                                    value={searchTerm} 
                                    onChange={handleSearchTermChange} 
                                    className="w-full border border-gray-300 pl-9 pr-2 py-1 rounded text-sm focus:ring-1 focus:ring-blue-500 focus:border-blue-500" 
                                />
                            </div>
                        </div>

                        <div className="col-span-6 md:col-span-2">
                            <label className="block text-[10px] font-bold text-gray-500 uppercase mb-1">Data</label>
                            <input 
                                name="data" 
                                type="date" 
                                value={filters.data} 
                                onChange={handleFilterChange} 
                                className="w-full border border-gray-300 px-2 py-1 rounded text-sm focus:ring-1 focus:ring-blue-500" 
                            />
                        </div>

                        <div className="col-span-6 md:col-span-2">
                            <label className="block text-[10px] font-bold text-gray-500 uppercase mb-1">Pelotão</label>
                            <select 
                                name="pelotaoId" 
                                value={filters.pelotaoId} 
                                onChange={handleFilterChange} 
                                className="w-full border border-gray-300 px-2 py-1 rounded text-sm focus:ring-1 focus:ring-blue-500"
                            >
                                <option value="">Todos</option>
                                {allPelotoes.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
                            </select>
                        </div>

                        <div className="col-span-6 md:col-span-2">
                            <label className="block text-[10px] font-bold text-gray-500 uppercase mb-1">Local</label>
                            <select 
                                name="localId" 
                                value={filters.localId} 
                                onChange={handleFilterChange} 
                                className="w-full border border-gray-300 px-2 py-1 rounded text-sm focus:ring-1 focus:ring-blue-500"
                            >
                                <option value="">Todos</option>
                                {allLocais.map(l => <option key={l.id} value={l.id}>{l.nome}</option>)}
                            </select>
                        </div>

                        <div className="col-span-6 md:col-span-1">
                            <label className="block text-[10px] font-bold text-gray-500 uppercase mb-1">Status</label>
                            <select 
                                name="status" 
                                value={filters.status} 
                                onChange={handleFilterChange} 
                                className="w-full border border-gray-300 px-2 py-1 rounded text-sm focus:ring-1 focus:ring-blue-500"
                            >
                                <option value="">Todos</option>
                                <option value="agendado">Agendado</option>
                                <option value="realizado">Realizado</option>
                                <option value="impossibilidade">Impossib.</option>
                            </select>
                        </div>

                        <div className="col-span-6 md:col-span-1">
                            <label className="block text-[10px] font-bold text-gray-500 uppercase mb-1">Tipo</label>
                            <select 
                                name="tipo" 
                                value={filters.tipo} 
                                onChange={handleFilterChange} 
                                className="w-full border border-gray-300 px-2 py-1 rounded text-sm focus:ring-1 focus:ring-blue-500"
                            >
                                <option value="">Todos</option>
                                <option value="PCO">PCO</option>
                                <option value="PJ">PJ</option>
                            </select>
                        </div>

                        <div className="col-span-12 md:col-span-12 lg:col-span-12 flex justify-end mt-2">
                             <Button 
                                onClick={handleSearch} 
                                variant="primary" 
                                className="w-full md:w-auto flex items-center justify-center gap-2 h-9 text-sm px-6"
                            >
                                <SearchIcon /> Pesquisar
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="bg-white shadow-lg rounded-xl overflow-x-auto border border-gray-200">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr><th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Data</th><th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cadete</th><th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Pelotão</th><th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Local</th><th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th><th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Turno</th><th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Relatório</th></tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {!searchPerformed ? (<tr><td colSpan="7" className="text-center py-10 text-gray-500"><div className="flex flex-col items-center justify-center"><SearchIcon /><span className="mt-2 text-lg font-medium">Utilize os filtros acima para pesquisar</span><span className="text-sm">Os resultados aparecerão aqui.</span></div></td></tr>) : filteredEscolhas.length === 0 ? (<tr><td colSpan="7" className="text-center py-10 text-gray-500">Nenhum registro encontrado para os filtros aplicados.</td></tr>) : (
                        filteredEscolhas.map(e => {
                            const cadete = userMap.get(e.cadete_id); const pelotao = pelotaoMap.get(e.pelotao_id); const relatorio = relatorioMap.get(e.id);
                            const nomeDisplay = cadete?.nome || e.cadete_nome; const reDisplay = cadete?.matricula ? `RE: ${cadete.matricula}` : (cadete?.cpf ? `CPF: ${cadete.cpf}` : 'Externo'); const pelotaoDisplay = pelotao?.nome || e.pelotao_origem || 'N/D';
                            let statusComp;
                            if (e.opcao_impossibilidade) { statusComp = <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${e.data ? 'bg-orange-100 text-orange-800' : 'bg-red-100 text-red-800'}`}>Impossibilidade</span>; } 
                            else if (e.data) { const dataEstagioStr = getNormalizedDateString(e.data); if (dataEstagioStr < hojeStr) { statusComp = <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">Realizado</span>; } else { statusComp = <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">Agendado</span>; } } 
                            else { statusComp = <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800">N/A</span>; }
                            return (
                              <tr key={e.id} className="hover:bg-gray-50"><td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{e.data ? formatarData(e.data) : 'N/D (Geral)'}</td><td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 font-medium">{nomeDisplay}<span className="block text-xs text-gray-500">{reDisplay}</span></td><td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{pelotaoDisplay}</td><td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{e.local_nome || 'N/D'}</td><td className="px-6 py-4 whitespace-nowrap text-sm">{statusComp}</td><td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{e.turno || 'N/A'}</td><td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">{relatorio ? (<Button onClick={() => handleOpenReportView(e)} variant="outline" className={`text-xs py-1 px-2 flex items-center justify-end ml-auto ${relatorio.preceptor?.posto_nome ? 'text-green-600 border-green-600' : 'text-blue-600 border-blue-600'}`}>{relatorio.preceptor?.posto_nome ? 'Ver Avaliação' : 'Ver Rascunho'} <FileTextIcon /></Button>) : (<span className="text-xs text-gray-400">Pendente</span>)}</td></tr>
                            );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
            </div>
        )}

        {/* ABA GERENCIAR ESCOLHAS (NOVA) */}
        {activeTab === 'gerenciar_escolhas' && renderGerenciarEscolhas()}

        {/* ABA Locais */}
        {activeTab === 'locais' && (
            <div className="space-y-6">
          <div className="p-4 bg-white rounded-lg shadow">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold">Gerenciar Locais</h3>
              <Button onClick={() => handleOpenModalLocal()} variant="success">Novo Local</Button>
            </div>
            <ul className="divide-y divide-gray-200">
              {allLocais.map(l => (
                <li key={l.id} className="py-2 flex justify-between items-center">
                  <div>
                    <p className="text-gray-700">{l.nome}</p>
                    <p className="text-sm text-gray-500">
                        Tipo: {l.tipo} 
                        {l.latitude && l.longitude && <span className="block text-xs text-gray-400">Coords: {l.latitude}, {l.longitude}</span>}
                    </p>
                  </div>
                  <div className="space-x-2">
                    <Button onClick={() => handleOpenModalLocal(l)} variant="outline">Editar</Button>
                    <Button onClick={() => confirmDelete(l.id)} variant="danger">Excluir</Button>
                  </div>
                </li>
              ))}
              {allLocais.length === 0 && <p className="text-gray-500 text-center py-2">Nenhum local cadastrado.</p>}
            </ul>
          </div>
        </div>
        )}
      
        {/* ABA GRÁFICOS */}
        {activeTab === 'graficos' && (
            <div className="animate-fade-in space-y-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div className="p-6 bg-white rounded-xl shadow-lg border border-gray-200 hover:shadow-xl transition-shadow"><div className="relative h-64"><canvas ref={chartPcoMaisRef}></canvas></div></div>
                    <div className="p-6 bg-white rounded-xl shadow-lg border border-gray-200 hover:shadow-xl transition-shadow"><div className="relative h-64"><canvas ref={chartPcoMenosRef}></canvas></div></div>
                    <div className="p-6 bg-white rounded-xl shadow-lg border border-gray-200 hover:shadow-xl transition-shadow"><div className="relative h-64"><canvas ref={chartPjMaisRef}></canvas></div></div>
                    <div className="p-6 bg-white rounded-xl shadow-lg border border-gray-200 hover:shadow-xl transition-shadow"><div className="relative h-64"><canvas ref={chartPjMenosRef}></canvas></div></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <RankingTable title="Ranking Completo de Locais PCO (Mais Escolhidos)" data={chartData.fullPCO} color="blue" />
                    <RankingTable title="Ranking Completo de Locais PJ (Mais Escolhidos)" data={chartData.fullPJ} color="green" />
                </div>
            </div>
        )}

        {/* ABA MAPA */}
        {activeTab === 'mapa' && (
            <div className="animate-fade-in space-y-4">
                {diasAgrupados.length === 0 ? (
                    <div className="p-8 text-center bg-gray-100 rounded-lg text-gray-500">
                        Não há estágios agendados no sistema para exibir no mapa.
                    </div>
                ) : (
                    <>
                        <div className="mb-2">
                            <div className="flex overflow-x-auto space-x-2 pb-2 mt-1 scrollbar-hide">
                                {mesesAgrupados.map((mes) => (
                                    <button
                                        key={mes.key}
                                        onClick={() => setSelectedMonthTab(mes.key)}
                                        className={`px-4 py-1.5 rounded-lg text-sm font-bold whitespace-nowrap transition-colors border ${
                                            selectedMonthTab === mes.key
                                                ? 'bg-gray-800 text-white border-gray-800 shadow'
                                                : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'
                                        }`}
                                    >
                                        {mes.nome.toUpperCase()}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="mb-4">
                            <div className="flex overflow-x-auto space-x-2 pb-2 scrollbar-hide">
                                {mesSelecionadoObj && mesSelecionadoObj.dias.map((dia) => (
                                    <button
                                        key={dia.dataStr}
                                        onClick={() => setSelectedDateTab(dia.dataStr)}
                                        className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors border ${
                                            selectedDateTab === dia.dataStr
                                                ? 'bg-blue-600 text-white border-blue-600 shadow-md'
                                                : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50 hover:border-gray-400'
                                        }`}
                                    >
                                        {dia.dataDisplay}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-lg h-full border border-gray-200">
                            <div className="w-full">
                                {mapData.length > 0 ? (
                                    <CadeteMap locais={mapData} />
                                ) : (
                                    <div className="p-8 text-center bg-gray-50 rounded-lg border border-gray-200 text-gray-500">
                                        Nenhum efetivo alocado em locais com coordenadas para este dia.
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
        )}
      
      </div>
      
      {/* Modais */}
      <Modal show={showSignatureModal} onClose={() => setShowSignatureModal(false)} title="Configurar Assinaturas da Certidão" size="lg">
        <form onSubmit={(e) => { e.preventDefault(); handleSaveAndGenerateCertificate(); }} className="space-y-4">
            <p className="text-sm text-gray-600">Configure os responsáveis pela assinatura da certidão. Estes dados serão salvos no seu perfil para uso futuro.</p>
            <fieldset className="border p-4 rounded-lg"><legend className="text-base font-medium text-gray-900 px-2">1ª Assinatura (Superior)</legend><div className="grid grid-cols-1 md:grid-cols-2 gap-4"><div><label className="block text-sm font-medium text-gray-700">Nome Completo</label><input name="nome1" value={signatureData.nome1} onChange={handleSignatureFormChange} required className="w-full border p-2 rounded" placeholder="Ex: NOME COMPLETO DO CHEFE" /></div><div><label className="block text-sm font-medium text-gray-700">Posto/Função</label><input name="posto1" value={signatureData.posto1} onChange={handleSignatureFormChange} required className="w-full border p-2 rounded" placeholder="Ex: Ch C Op Ens" /></div></div></fieldset>
            <fieldset className="border p-4 rounded-lg"><legend className="text-base font-medium text-gray-900 px-2">2ª Assinatura (Inferior)</legend><div className="grid grid-cols-1 md:grid-cols-2 gap-4"><div><label className="block text-sm font-medium text-gray-700">Nome Completo</label><input name="nome2" value={signatureData.nome2} onChange={handleSignatureFormChange} required className="w-full border p-2 rounded" placeholder="Ex: NOME COMPLETO DO CMT" /></div><div><label className="block text-sm font-medium text-gray-700">Posto/Função</label><input name="posto2" value={signatureData.posto2} onChange={handleSignatureFormChange} required className="w-full border p-2 rounded" placeholder="Ex: Cmt Corpo de Alunos" /></div></div></fieldset>
            <div className="flex justify-end gap-3 pt-4 border-t"><Button type="button" onClick={() => setShowSignatureModal(false)} variant="secondary" disabled={isProcessingSignature}>Cancelar</Button><Button type="submit" variant="primary" disabled={isProcessingSignature}>{isProcessingSignature ? "Salvando e Gerando..." : "Salvar e Gerar Certidão"}</Button></div>
        </form>
      </Modal>
      
      {reportViewData && reportViewEscolha && (<RelatorioEstagioModal show={showReportViewModal} onClose={() => setShowReportViewModal(false)} escolha={reportViewEscolha} relatorioExistente={reportViewData} handleSaveRelatorio={() => {}} processing={false} error={''} handleGerarLinkPreceptor={() => {}} />)}

      {/* NOVO: Modal de Confirmação de Exclusão (SOE) */}
      <Modal show={showConfirm} onClose={() => setShowConfirm(false)} title="Confirmar Exclusão" size="sm">
        <p>Tem certeza que deseja excluir este item? Esta ação não pode ser desfeita.</p>
        <p className="text-sm text-yellow-700 bg-yellow-50 p-2 rounded-md my-3">
            Atenção: A exclusão de uma escolha remove o registro permanentemente. Se for um estágio já realizado, os dados do relatório também podem perder a referência.
        </p>
        {error && <p className="text-red-600 mt-2">{error}</p>}
        <div className="flex justify-end gap-3 mt-4">
            <Button onClick={() => { setShowConfirm(false); setError(''); }} variant="secondary">Cancelar</Button>
            <Button onClick={handleDelete} variant="danger">Excluir</Button>
        </div>
      </Modal>

    </div>
  );
};